import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { SnackbarProvider } from 'notistack';
import { SettingsState, Store } from './store/types';
import AuthContext from './contexts/AuthContext';

// project import
import Routes from './routes';
import ThemeCustomization from './themes';
import TranslationContextProvider from './contexts/TranslationContext';
import ScrollTop from './components/ScrollTop';

// ==============================|| APP - THEME, ROUTER, LOCAL  ||============================== //
import './App.css';
import SnackbarComponents from './components/snackbar';
import SearchContextProvider from './contexts/SearchContext';

const App = () => {
    const { networkError } = useSelector<Store, SettingsState>(
        state => state.settings,
    );

    // rerender on networkError
    return useMemo(() => {
        return (
            <TranslationContextProvider allowedToSave={false}>
                <AuthContext>
                    <ThemeCustomization>
                        <SnackbarProvider
                            maxSnack={3}
                            TransitionProps={{}}
                            Components={SnackbarComponents}>
                            <SearchContextProvider>
                                <ScrollTop>
                                    <Routes />
                                </ScrollTop>
                            </SearchContextProvider>
                        </SnackbarProvider>
                    </ThemeCustomization>
                </AuthContext>
            </TranslationContextProvider>
        );
    }, [networkError]);
};

export default App;
